import {StyleSheet} from 'react-native';

import {onyxLighter, white} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  thumb: {
    color: white,
  },
  track: {
    backgroundColor: onyxLighter,
  },
});
